// import { useContext } from 'react';

import Button from "../components/Button";
import CustomeIcon from "../components/CustomeIcon";
import Helper from "../utils/Helper";
import MyAppliances from "./MyAppliances";
// import CartContext from '../store/cart-context'
const ReviewMyKitchen = (props) => {
  // console.log('ReviewMyKitchen', window.dummyCart.length);
  // console.log('ReviewMyKitchen', props.cartUpdate);
  // const cartCtx = useContext(CartContext);

  // console.log('cartCtx', cartCtx)
  return (
    <>
      {!props.cartUpdate &&
        <Button classList="reviewMyKitchen" clickFunction={props.reviewMyKitchenFunc}>REVIEW MY KITCHEN</Button>
      }
      {
        props.myKitchenPopupVisibility && <><div id="overLay" className="backgroundOverlay" onClick={props.reviewMyKitchenFunc}></div><div className="myKitchenPopup" id="myKitchenShowHide">
          
          <MyAppliances clickFunc={props.reviewMyKitchenFunc}/>

        </div></>
      }
    </>
  );
}

export default ReviewMyKitchen;